import React from 'react';
import { useSelector } from 'react-redux';
import { openInNewTab } from '../../../../utils/utils';
import Icon from '../../../../components/ui/icons/Icon';
import iconsList from '../../../../components/ui/icons/iconsList';import deskImageHe from '../../../../assets/plethoraEmergency/deskImgHe.png';
import desktop1Ar from '../../../../assets/plethoraEmergency/deskImgAr.png';
import logoPlethoraEmergencyHe from '../../../../assets/plethoraEmergency/logoPlethoraEmergencyHe.png';
import logoPlethoraEmergencyAr from '../../../../assets/plethoraEmergency/logoPlethoraEmergencyAr.png';
import classes from './PlethoraLanding.module.css';


const PlethoraLanding = ({ contest }) => {

  const { lang, texts } = useSelector(state => state.translate);

  return (
    <div className={classes.contentFrame} >
      <div className={classes.rightSection}>
        <img src={lang === 'he' ? deskImageHe : desktop1Ar} alt={contest.contestName} className={classes.heroImage} />
      </div>
      <div className={classes.leftSection}>
        <img src={lang === 'he' ? logoPlethoraEmergencyHe : logoPlethoraEmergencyAr} alt={contest.contestName} className={classes.logoStemCraft} />
        <p className={classes.textPlethoraEmergency}>{texts.plethoraEmergencyText}</p>
        <button onClick={() => openInNewTab(contest?.providers?.[0]?.url)} className={classes.buttonLink} >
          <p className={classes.buttonLinkText}>{texts.toPlay}</p>
        </button>
        <div className={classes.desktopMessage}>
          <Icon name={iconsList.desktop} size={24} className={classes.desktopIcon} />
          <p className={classes.desktopText}>{texts.moveToDesktop}</p>
        </div>
      </div>
    </div>
  );
};

export default PlethoraLanding;
